
import { useLanguage } from '../../../contexts/LanguageContext';
import translations from '../../../i18n/translations';

export default function About() {
  const { language } = useLanguage();
  const t = translations[language].about;

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block px-4 py-1.5 bg-gray-100 text-gray-600 text-xs font-semibold tracking-wider rounded-full mb-6">
              {t.badge}
            </div>

            <h2 className="text-5xl font-bold text-gray-900 mb-4 leading-tight">
              {t.title}
              <br />
              <span className="italic font-serif">{t.titleItalic}</span>
            </h2>

            <div className="w-32 h-1 bg-[#00A3FF] mb-8"></div>

            <div className="space-y-6 text-gray-600 leading-relaxed">
              <p>{t.p1}</p>
              <p>{t.p2}</p>

              <div className="pt-4">
                <h3 className="text-xl font-bold text-gray-900 mb-4">{t.whyTitle}</h3>
                <ul className="space-y-3">
                  {t.points.map((point, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-[#00A3FF] text-xl mr-3 mt-0.5"></i>
                      <div>
                        <span className="font-semibold text-gray-900">{point.label}</span>
                        <span className="text-gray-600">{point.text}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="flex flex-wrap gap-3 mt-8">
              {t.tags.map((tag, idx) => (
                <span key={idx} className="px-5 py-2 bg-blue-50 text-[#00A3FF] text-sm font-medium rounded-full whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/48dde99e8fd8a26df059daa5a847ba45/ac66ebb6990a3e737df51bc7aa6c5f88.png"
                alt="Professional IT Team"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>

            {/* Floating Stats Card */}
            <div className="absolute -bottom-16 -right-8 bg-white rounded-2xl shadow-2xl p-5 w-48">
              <div className="space-y-4">
                <div>
                  <div className="text-2xl font-bold text-[#FF6B35] mb-0.5">500+</div>
                  <div className="text-xs text-gray-600">{t.stats.projects}</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-[#00A3FF] mb-0.5">99.9%</div>
                  <div className="text-xs text-gray-600">{t.stats.uptime}</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-700 mb-0.5">24/7</div>
                  <div className="text-xs text-gray-600">{t.stats.support}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
